var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", [
    _c("div", { staticClass: "inner-wrapper" }, [
      _c("section", { staticClass: "content-body", attrs: { role: "main" } }, [
        _c("div", { staticClass: "grid grid-logo" }, [
          _c("div", { staticClass: "row space-bot" }, [
            _c("div", { staticStyle: { "text-align": "center" } }, [
              _c("a", { attrs: { href: "/" } }, [
                _vm.rs_data.logo
                  ? _c("img", {
                      staticClass: "logo",
                      staticStyle: { width: "140px" },
                      attrs: {
                        src: "/assets/img/logo/logo-rs/" + _vm.rs_data.logo,
                        alt: "",
                      },
                    })
                  : _vm._e(),
              ]),
            ]),
          ]),
        ]),
        _vm._v(" "),
        _c(
          "div",
          {
            staticClass: "undermenuarea",
            staticStyle: { "background-color": "#007d7d" },
          },
          [
            _c("div", { staticClass: "boxedshadow" }),
            _vm._v(" "),
            _c("div", { staticClass: "grid" }, [
              _c("div", { staticClass: "row" }, [
                _c(
                  "div",
                  {
                    staticClass: "c12",
                    staticStyle: { "text-align": "center" },
                  },
                  [
                    _c(
                      "div",
                      {
                        staticClass: "titlehead",
                        staticStyle: { "text-align": "center" },
                      },
                      [
                        _c(
                          "span",
                          {
                            staticStyle: {
                              "font-size": "26px",
                              "font-weight": "bold",
                            },
                          },
                          [_vm._v(_vm._s(_vm.rs_data.app_title))]
                        ),
                        _vm._v(" "),
                        _c(
                          "p",
                          {
                            staticStyle: {
                              "font-size": "18px",
                              "margin-bottom": "-26px",
                            },
                          },
                          [_vm._v(_vm._s(_vm.rs_data.app_desc))]
                        ),
                        _vm._v(" "),
                        _c("br"),
                        _c(
                          "span",
                          {
                            staticStyle: {
                              "font-size": "26px",
                              "font-weight": "bold",
                            },
                          },
                          [_vm._v(_vm._s(_vm.rs_data.name))]
                        ),
                        _vm._v(" "),
                        _c("br"),
                        _c(
                          "span",
                          {
                            staticStyle: {
                              "font-size": "20px",
                              "font-weight": "bold",
                            },
                          },
                          [
                            _vm._v(
                              _vm._s(
                                _vm.rs_data.address +
                                  " Telp. " +
                                  _vm.rs_data.phone
                              )
                            ),
                          ]
                        ),
                      ]
                    ),
                    _vm._v(" "),
                    _c(
                      "router-link",
                      { staticStyle: { color: "white" }, attrs: { to: "/" } },
                      [
                        _c("i", { staticClass: "fa fa-home" }),
                        _vm._v("  Halaman Utama"),
                      ]
                    ),
                  ],
                  1
                ),
              ]),
            ]),
          ]
        ),
        _vm._v(" "),
        _vm.user
          ? _c(
              "div",
              {
                staticClass: "undersliderblack",
                staticStyle: { height: "87px" },
              },
              [
                _c("div", { staticClass: "grid" }, [
                  _c("div", { staticClass: "row space-bot" }, [
                    _c("div", { staticClass: "c12" }, [
                      _c("nav", { attrs: { id: "topNav" } }, [
                        _c("ul", { attrs: { id: "responsivemenu" } }, [
                          _c(
                            "li",
                            {},
                            [
                              _c(
                                "router-link",
                                {
                                  staticStyle: { color: "white" },
                                  attrs: { to: "/" },
                                },
                                [
                                  _c("i", { staticClass: "fa fa-home" }),
                                  _vm._v(" Home"),
                                ]
                              ),
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c(
                            "li",
                            {},
                            [
                              _c(
                                "router-link",
                                {
                                  staticStyle: { color: "white" },
                                  attrs: { to: "/portal" },
                                },
                                [
                                  _c("i", { staticClass: "fa fa-cog" }),
                                  _vm._v(" Portal"),
                                ]
                              ),
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c(
                            "li",
                            {},
                            [
                              _c(
                                "router-link",
                                {
                                  staticStyle: { color: "white" },
                                  attrs: { to: "#" },
                                  nativeOn: {
                                    click: function ($event) {
                                      return _vm.doLogout.apply(null, arguments)
                                    },
                                  },
                                },
                                [
                                  _c("i", { staticClass: "fa fa-sign-out" }),
                                  _vm._v(" Logout"),
                                ]
                              ),
                            ],
                            1
                          ),
                        ]),
                      ]),
                    ]),
                  ]),
                ]),
              ]
            )
          : _vm._e(),
      ]),
    ]),
    _vm._v(" "),
    _c("div", [
      _c(
        "section",
        { attrs: { role: "main" } },
        [_c("b-container", { attrs: { fluid: "md" } }, [_c("router-view")], 1)],
        1
      ),
    ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }